import React, { useContext } from "react";
import { QuestionContext } from "../../context";
import { Radio } from "antd";
import { RichText } from "../RichText";
import classNames from "classnames";
import "./index.scss";

export function OptionsSingle({ className, style }: RenderComponent) {
    const ctx = useContext(QuestionContext);
    if (ctx.type !== "SingleChoice") throw new Error("error type data");

    return (
        <Radio.Group
            value={ctx.data.answer}
            className={classNames("QuestionOptionsSingle", className)}
            style={style}>
            {ctx.data.options.map((item, index) => (
                <Radio key={item.id} value={item.id}>
                    <RichText>
                        {`${String.fromCharCode(65 + index)}.  ${item.content}`}
                    </RichText>
                </Radio>
            ))}
        </Radio.Group>
    );
}
